var exports = {
  "k": "xa15a2ab7--d97561--container",
  "R": "xa15a2ab7--d97561--more-button",
};

module.exports = exports;
